const {flushDataLayerEvents} = require('./navigationEventQueue');
const {
    installPublicApi,
    recordDiagnostic,
} = require('./diagnostics');
const {observeAnalyticsRequests} = require('./analyticsRequestObserver');
const {loadGtm} = require('./gtmLoader');

window.dataLayer = window.dataLayer || [];
installPublicApi();
observeAnalyticsRequests();

loadGtm(window, document, 'GTM-MPMF5FK', recordDiagnostic);

const currentPageType = typeof window.kdAnalytics === 'object'
    ? window.kdAnalytics.pageType
    : null;

flushDataLayerEvents(currentPageType);
